import React from 'react';
import { Spinner } from 'flowbite-react';

export const Loading: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center p-10">
      <Spinner
        size="xl"
        color="primary"
        theme={{ color: { primary: 'fill-primary-500' } }}
      />
    </div>
  );
};
